export const zIndex = {
    SectionWrapper: 3,
    Station: 1,
    ActiveStation: 2,
    PathDescription: 4,
    onboardingHeaderZIndex: 10
};
